import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

export type LegislationNormType = "marginalia" | "superior";

export interface LegislationNorm {
  nome: string;
  id: string;
  tipo: LegislationNormType;
}

export const getLegislationNorms = async () => {
  const response = await apiInstance.get<LegislationNorm[]>("legislacao/tipos");
  return response.data;
};

export const useLegislationNormsQuery = () =>
  useQuery({
    queryKey: ["get-legislation-norms"],
    queryFn: () => getLegislationNorms(),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: (count) => {
      return count < 2;
    },
  });
